import { Route, Routes } from 'react-router'
import { DocindexList } from './DocindexList'

function DocIndexPage() {
  return (
    <Routes>
      <Route index element={<DocindexList />} />
    </Routes>
  )
}

export default DocIndexPage
